// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__29xPa","title":"Header_title__1rlAd","side":"Header_side__1e1aG"};